<template>
	<div class="footer">
		<div class="container">
			<div class="footer-top-nav">
				<router-link to="/terms">이용약관</router-link>
				<router-link to="/privacyPolicy">개인정보처리방침</router-link>
			</div>

			<el-row :gutter="40" class="footer-main">
				<el-col :xs="24" :sm="14">
					<div class="company-section">
						<h3 class="company-name">(주)고로켓고</h3>
						<div class="info-details">
							<p>대표이사 : 김미현 ㅣ 사업자등록번호 : 109-86-45763 ㅣ 통신판매업신고번호 : 제2026-서울 강남구-1322호</p>
							<p>주소 : 서울시 강남구 테헤란로 620 11층</p>
							<p>이메일 : CS@goroketgo.com ㅣ 팩스번호 : 02--0899 ㅣ 개인정보관리책임자 : 정원교</p>
						</div>
						<div class="disclaimer">
							<p>고로켓고는 관세법 등의 관련규정을 준수하고, 고객의 불법사항 요청에는 협조하지 않습니다.</p>
							<p>또한, 자가사용목적을 제외한 판매용 및 사업용도 등으로 구입한 상품은 사업자 명의로 배송신청을 하셔야 하며,</p>
							<p>허위신고로 인해 발생하는 불이익은 책임지지 않습니다.</p>
						</div>
						<p class="copyright">Copyright 2026 goroketgo All Rights Reserved.</p>
					</div>
				</el-col>
				<el-col :xs="24" :sm="10">
					<div class="contact-section">
						<h3 class="contact-title">고객센터</h3>
						<div class="tel-number">1566-9090</div>
						<p class="working-hours">1:1 문의를 통한 접수는 24시간 가능합니다.</p>					
					</div>
					<div class="rate-section" v-if="rate">
						<div class="rate-container">
							<div class="rate-row">
								<span class="rate-label">고시환율</span>
								<span class="rate-value">1 CNY = {{ rawRate }} KRW</span>
							</div>
							<div class="rate-divider"></div>
							<div class="rate-row highlight-row">
								<span class="rate-label">적용환율</span>
								<span class="rate-value">1 CNY = {{ rate }} KRW</span>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'

	export default {
		data() {
		  return {
			rate: 0,
			rawRate: 0
		  };
		},
		computed: {
		  isMobile() {
		    return window.innerWidth <= 768;
		  }
		},
		created() {
			this.getRate();
		},
		methods: {
			getRate() {
				request.post('/index/getRate').then(res => {
					if (res.code === 1) {
						this.rate = res.data.rate;
						this.rawRate = res.data.raw_rate;
					}
				}).catch(err => {
					console.error('get rate error:', err);
				});
			}
		}
	  }
</script>

<style scoped>
	.footer {
		padding: 60px 0 80px;
		background-color: #1e3a5f;
		color: #fff;
		border-top: 3px solid #2B7DE9;
	}
	.container {
		max-width: 1400px;
		margin: 0 auto;
		padding: 0 40px;
	}
	.footer-top-nav {
		display: flex;
		gap: 30px;
		margin-bottom: 50px;
	}
	.footer-top-nav a {
		color: #fff;
		text-decoration: none;
		font-size: 15px;
		font-weight: 500;
	}
	.footer-main {
		display: flex;
		flex-wrap: wrap;
		text-align: left;
	}
	.company-name {
		font-size: 24px;
		font-weight: 700;
		margin-bottom: 15px;
		color: #fff;
	}
	.info-details {
		font-size: 14px;
		color: #999;
		line-height: 1.8;
		margin-bottom: 25px;
	}
	.disclaimer {
		font-size: 13px;
		color: #777;
		line-height: 1.6;
		margin-bottom: 25px;
	}
	.copyright {
		font-size: 13px;
		color: #555;
		margin-top: 30px;
	}
	.contact-section {
		padding-left: 20px;
	}
	.contact-title {
		font-size: 22px;
		font-weight: 700;
		margin-bottom: 10px;
	}
	.tel-number {
		font-size: 32px;
		font-weight: 800;
		color: #fff;
		margin-bottom: 10px;
	}
	.working-hours {
		font-size: 14px;
		color: #999;
		margin-bottom: 25px;
	}
	.contact-notice {
		font-size: 13px;
		color: #777;
		line-height: 1.6;
	}
	.rate-section {
		padding-left: 20px;
		margin-top: 20px;
	}
	.rate-container {
		background: rgba(255, 255, 255, 0.04);
		border: 1px solid rgba(255, 255, 255, 0.08);
		border-radius: 10px;
		padding: 12px 18px;
		display: inline-block;
		min-width: 340px;
	}
	.rate-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 13px;
		color: #999;
	}
	.rate-divider {
		height: 1px;
		background: rgba(255, 255, 255, 0.08);
		margin: 8px 0;
	}
	.rate-row.highlight-row {
		color: #fff;
		font-weight: bold;
	}
	.rate-row.highlight-row .rate-value {
		color: #4c9dfb;
	}

	@media (max-width: 768px) {
		.container {
			padding: 0 20px;
		}
		.footer-top-nav {
			gap: 15px;
			flex-wrap: wrap;
		}
		.contact-section {
			padding-left: 0;
			margin-top: 40px;
			border-top: 1px solid #333;
			padding-top: 40px;
		}
		.rate-section {
			padding-left: 0;
			margin-top: 15px;
		}
	}
</style>